/**
 * Created by afuhr on 07.07.2016.
 */
import {RouterModule, Routes} from "@angular/router";
import {VisbosTouchClientComponent} from "./visbos-touch-client.component";
import {SecurityTokenGuardService} from "./services/security-token-guard.service";
import {TouchNavigationMenuComponent} from "./ui/navigation/touch-navigation-menu/touch-navigation-menu.component";
import {TouchScanComponent} from "./ui/touch-scan/touch-scan.component";
import {TouchAuthorizedGuard} from "../core/visbos-core/authorization/guards/touch-authorized.guard";
import {WithdrawalLogViewComponent} from "../store-management/withdrawal/withdrawal-log-view/withdrawal-log-view.component";
import {TouchDepotYardSearchComponent} from "./ui/touch-depot-yard-search/touch-depot-yard-search.component";
import {ManualWarehousingComponent} from "./ui/touch-warehousing/manual-warehousing/manual-warehousing.component";
import {TouchFillUpWizardComponent} from "./ui/touch-fill-up/touch-fill-up-wizard/touch-fill-up-wizard.component";
import {RedirectToVtouchComponent} from "./ui/vtouch/redirect-to-vtouch/redirect-to-vtouch.component";
import {TouchStocktakingMenuComponent} from "./ui/touch-stocktaking/touch-stocktaking-menu/touch-stocktaking-menu.component";
import {StocktakingWizardComponent} from "./ui/touch-stocktaking/stocktaking-wizard/stocktaking-wizard.component";
import {TouchDepotNeedsWizardComponent} from "./ui/touch-depot-needs/touch-depot-needs-wizard/touch-depot-needs-wizard.component";
import {TouchAssetStatusComponent} from './ui/touch-asset-status/touch-asset-status.component';
import { TouchMarriageWizzardComponent } from "./ui/touch-marriage/touch-marriage-wizzard/touch-marriage-wizzard.component";


const visbosTouchClientRoutes: Routes = [
  {
    path: 'touch',
    component: VisbosTouchClientComponent,
    canActivate: [SecurityTokenGuardService],
    data: {
      touchMode: true
    },
    children: [
      {
        path: '',
        canActivateChild: [TouchAuthorizedGuard],
        children: [
          {
            path: '',
            component: TouchNavigationMenuComponent
          },
          {
            path: 'scannen',
            component: TouchScanComponent,
          },
          {
            path: 'wareneingang',
            component: ManualWarehousingComponent,
          },
          {
            path: 'scanlog',
            component: WithdrawalLogViewComponent
          },
          {
            path: 'artikelsuche',
            component: TouchDepotYardSearchComponent
          },
          {
            path: 'assetstatus',
            component: TouchAssetStatusComponent
          },
          {
            path: 'lager-auffuellen',
            component: TouchFillUpWizardComponent
          },
          {
            path: 'lager-bedarf',
            component: TouchDepotNeedsWizardComponent
          },
          {
            path: 'vtouch',
            component: RedirectToVtouchComponent
          },
          {
            path: 'verheiraten',
            component: TouchMarriageWizzardComponent
          },
          {
            path: 'inventur',
            children: [
              {
                path: '',
                component: TouchStocktakingMenuComponent
              },
              {
                path: 'neu',
                component: StocktakingWizardComponent
              },
              {
                path: ':stocktakingCuid',
                component: StocktakingWizardComponent
              },
            ]
          }
        ]
      }
    ]
  },
];

//TODO: Adapt path to standard value of logged in user

export const visbosTouchClientRoutingProviders: any[] = [SecurityTokenGuardService];

export const visbosTouchClientRouting = RouterModule.forChild(visbosTouchClientRoutes);




// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/visbos-touch-client.routes.ts